<template>
    <div style="height: 100%">
        <div style="height: 73px; border-bottom: 12px solid #dbd9d980">
        <div class="sub-title-con">
            颜色说明：
            <span class="tag-correct">错别字</span>
            <span class="tag-sense">敏感词</span>
            <span class="tag-sense1">禁用词</span>
            <span class="tag-sense2">疑似错别字</span>
        </div>
        <div style="float: right; padding: 7px; font-size: 15px; margin: 5px 30px">
            <el-checkbox v-model="keep_doc_style">保留原文格式</el-checkbox>
            <el-checkbox v-model="isEnglish" v-if="showEnglish">英文检测</el-checkbox>

            <span>审核方式：</span>
            <el-tooltip class="item" effect="dark" content="增强模式：语义精准识别，识别范围广" placement="bottom">
                <el-checkbox v-model="auditPattern1">增强模式<i v-if="isXunFeiError" class="el-icon-warning" style="color: red;"></i></el-checkbox>
            </el-tooltip>
            <!-- :content="statuss == 1 || statuss == 2 ? '升级用户即可开启：智能模式，智能分析，判定范围更广' : '智能模式：智能识别，审核时间较长'" -->
            <el-tooltip class="item" effect="dark" content = "智能模式：智能识别，审核时间较长" placement="bottom">
                <el-checkbox v-model="auditPattern2" v-if="showSmartMode && !showAISmart">智能模式<i v-if="isSmartError" class="el-icon-warning" style="color: red;"></i></el-checkbox>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="智能模式：智能识别，审核时间较长" placement="bottom">
                <el-checkbox v-model="auditPatternAISmart" v-if="showAISmart">智能模式</el-checkbox>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content = "DeepSeek模式：以DeepSeek-R1等先进模型为核心，通过多维度校对能力重新定义文本处理标准" placement="bottom">
                <el-checkbox v-model="auditPatternDP" v-if="showDeepSeekMode && !showAISmart">DeepSeek模式<i v-if="isSmartError" class="el-icon-warning" style="color: red;"></i></el-checkbox>
            </el-tooltip>
            <el-tooltip v-if="$root.clientType == 0 || $root.clientType === 2" class="item" effect="dark" content="样本模式：通过样本库匹配的方式识别错误">
                <el-checkbox v-model="auditPatternSample" v-if="showPatternSample">样本模式</el-checkbox>
            </el-tooltip>
            <!-- :content="statuss == 1 || statuss == 2 ? '升级用户即可开启：控制疑似错别字校验开关' : '控制疑似错别字校验开关'" -->
            <!-- <el-tooltip class="item" effect="dark" content="控制疑似错别字校验开关" placement="bottom">
                <el-checkbox v-model="auditPattern3">疑似错别字</el-checkbox>
            </el-tooltip> -->
            <el-button
                style="padding: 10px; font-size: 15px; margin: 0 0 0 37px"
                :loading="btnAuditLoading" type="primary" @click="btnStartAudit_keepStyle()">
                一键审核
            </el-button>
            <el-button @click="btnResetContent">重置</el-button>
            <el-button @click="btnCleanResult">清空</el-button>
        </div>
        </div>
        <doc-audit v-show="auditResType == 'text'" ref="audit" :editable="true" :keepStyle="keep_doc_style" :showdpmode="auditPatternDP || auditPatternAISmart" :dpresult="deepseekResult" style="height: 84%;"></doc-audit>
        <!-- <media-audit v-show="auditResType == 'media'"></media-audit> -->
        <div style="height: 55px;">
            <el-button style="float: left; margin-left: 10px; margin-top: 10px;" v-if="!openDocCheck" disabled>文档审核</el-button>
            <el-upload v-else
                style="float: left; margin-left: 10px; margin-top: 10px;"
                :show-file-list="false" :http-request="btnUploadDocument"
                action="/cmsMateService/login.do?method=uploadLogo" v-loading="documentLoading"
                accept=".doc,.docx,.txt,.wps,.pdf,.jpg,.jpeg,.gif,.png,.bmp,.ppt,.pptx,.xls,.xlsx,.ofd">
                <el-button slot="trigger">文档审核</el-button>
            </el-upload>
            <el-button v-if="$root.clientType == 0 || ($root.clientType == 2 && openImgCheck)"
                :disabled="!openImgCheck" 
                style="float: left; margin-top: 10px; margin-left: 10px;" @click="$router.push({ path: '/media', query: { type: 1 } })">图片审核</el-button>
            <el-button v-if="userName !== 'hxxy' && ($root.clientType == 0 || ($root.clientType == 2 && openVideoCheck))" 
                :disabled="!openVideoCheck" 
                style="float: left; margin-top: 10px; margin-left: 10px;" @click="$router.push({ path: '/media', query: { type: 2 } })">视频审核</el-button>
            <el-button v-if="$root.clientType == 0 || ($root.clientType == 2 && openAudioCheck)" 
                :disabled="!openAudioCheck" 
                style="float: left; margin-top: 10px; margin-left: 10px;" @click="$router.push({ path: '/media', query: { type: 3 } })">音频审核</el-button>
            <el-button v-if="$root.clientType == 0 || ($root.clientType == 2 && openWebpageCheck)" 
                :disabled="!openWebpageCheck" 
                style="float: left; margin-top: 10px; margin-left: 10px;" @click="goWebPageAudit">网页审核</el-button>
            <div v-if="documentLoading" style="width: 350px; float: left; margin: 20px 0 0 10px;">
                <el-progress
                    :percentage="progressPercent" :text-inside="true" :show-text="true"
                    :stroke-width="24" status="success"
                    :striped-flow="true" :duration="10"
                    :format="(percentage) => (percentage === 100 ? '完成' : '上传中')"
                ></el-progress>
            </div>
            <el-button v-if="$root.clientType == 0 || ($root.clientType == 2 && openAICreation)" 
                :disabled="!openAICreation" 
                style="float: left; margin-top: 10px;" @click="goAIWrite">AI撰写</el-button>
            <!-- <div style="float: left; margin: 20px 0 0 10px;">
                <p>(1000字以内计为一次，超过1000字按多次计算)</p>
            </div> -->
        </div>
        <el-dialog title="导入链接" :visible.sync="importLinkDlg.show" width="700">
            <div>
                <el-input v-model="importLinkDlg.link" style="width: 600px;" placeholder="请输入页面的访问地址"></el-input>
                <el-button @click="btnImportLink" v-loading="importLinkDlg.loading">访问</el-button>
            </div>
            <div slot="footer"></div>
        </el-dialog>
        <el-dialog title="AI撰写" :visible.sync="AIWrite.show" width="700">
            <div>
                <div>创作主题：<el-input v-model="AIWrite.zhuti" style="display: inline-block; width: 600px;" placeholder="必填：请输入创作主题"></el-input></div>
                <div style="margin-top: 10px;">
                    创作背景：<el-input v-model="AIWrite.background" type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3, maxRows: 10 }" clearable style="display: inline-block; width: 600px;" placeholder="必填：请输入创作背景"></el-input>
                </div>
                <div style="margin-top: 10px;">
                    具体要求：<el-input v-model="AIWrite.detail" type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 3, maxRows: 10 }" clearable style="display: inline-block; width: 600px;" placeholder="选填：请输入其他创作要求"></el-input>
                </div>
            </div>
            <div slot="footer">
                <el-button @click="btnGenerateArticle" :loading="AIWrite.loading">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script type="text/javascript" src="http://files.cnblogs.com/files/heyiming/jquery-2.1.4.min.js"></script>

<script>
import DocAudit from './DocAudit.vue'
import MediaAudit from './MediaAudit.vue'
export default {
    components: { DocAudit, MediaAudit },
    data() {
        return {
            auditPatternSample: false,  // 是否开启了样本模式
            keep_doc_style: false,
            isEnglish: false,
            shows: false,
            statuss: 0,
            nickName: "",
            userName: '',
            genre: "",
            isDocFile: false,
            isHtmlPage: false,

            status: true,
            btnAuditLoading: false,
            exit: true,

            isXunFeiError: false,
            isSmartError: false,

            documentLoading: false,
            progressPercent: 0,
            uploadTimer: null,
            auditResType: 'text',       // text-常规文本审核  media-媒体审核，包含图片、视频
            importLinkDlg: {
                show: false,
                link: '',
                loading: false
            },
            AIWrite: {
                show: false,
                zhuti: '',
                background: '',
                detail: '',
                conversationId: '',
                loading: false
            },
            deepseekResult: ''
        };
    },

    methods: {
        goWebPageAudit () {
            if (this.userType !== 0 && this.userType !== 3) {
                this.$message.warning('没有权限')
                return
            }
            this.importLinkDlg.link = ''
            this.importLinkDlg.show = true
        },
        btnResetContent () {
            this.$refs.audit.resetAuditTxt()
            this.deepseekResult = ''
        },
        btnCleanResult () {
            this.$refs.audit.cleanAudit()
            this.isDocFile = false
            this.isHtmlPage = false
            this.deepseekResult = ''
        },
        btnStartAudit_keepStyle () {
            // var html = this.$refs.audit.getIframeAuditHtml()
            // this.$refs.audit.getCleanTextNew(html)
            // return
            // 先清空审核结果
            this.$refs.audit.setAuditResult([], [], [], [], [])
            this.$refs.audit.checkAuditHtml()
            var audit_text = this.$refs.audit.getCleanAuditTxt()
            // console.log('审核组件:', this.$refs.audit)
            console.log('是否开启样本模式：', this.auditPatternSample ? '是' : '否')
            var audit_len = audit_text.replace(/\n|\r/gi, "").length
            console.log('点击审核：', audit_text)
            console.log('字数：', audit_len)
            if (audit_text === '') {
                this.$message({ message: '监测内容不能为空，请输入内容', type: 'warning' })
                return
            }
            var userGernre = parseInt(sessionStorage.getItem('genre'))    // 0-系统 1-个人 2-单位
            // userType: 0-管理员 1-普通用户 2-高级用户 3-VIP用户 4-测试用户
            // 德州定制版本不限制字数
            if ((this.$root.clientType !== 1) && !this.isDocFile && !this.isHtmlPage) {   // 不是定制用户，且不是附件审核，才进行字数限制
                var limitWordNum = 0
                if (userGernre === 1 && this.userType === 1 && audit_len > 2000) {
                    limitWordNum = 2000
                } else if (userGernre === 1 && this.userType === 2 && audit_len > 4000) {
                    limitWordNum = 4000
                } else if (userGernre === 1 && this.userType === 3 && audit_len > 5000) {
                    limitWordNum = 5000
                } else if (userGernre === 2 && this.userType === 1 && audit_len > 5000) {
                    limitWordNum = 5000
                } else if (userGernre === 2 && this.userType === 2 && audit_len > 10000) {
                    limitWordNum = 10000
                } else if (userGernre === 2 && this.userType === 3 && audit_len > 200000) {
                    limitWordNum = 200000
                }
                if (limitWordNum > 0) {
                    this.$message({ type: 'warning', message: '您可在线检测字数为' + limitWordNum + '字以内的文章' })
                    return
                } else if (this.userType === 4 && audit_len > 1000) {
                    this.$message({ type: 'warning', message: '测试用户只支持1000字以下审核，可升级为正式用户审核更多内容。' })
                    return
                }
            }
            // 如果不保留原文格式，就清洗下网页标签
            if (this.keep_doc_style === false) {
                // console.log('不保留原文格式，重新设置审核文本', audit_text)
                this.$refs.audit.setAuditTxt(audit_text)
                this.deepseekResult = ''
                var audit_text = this.$refs.audit.getCleanAuditTxt()
            }

            // 提取内容中的图片地址
            var auditImgs = []
            var html = this.$refs.audit.getIframeAuditHtml()
            // console.log('提取图片：', html)
            var imgList = html.match(/<img[^>]* src=['"]([^'"]*)['"][^>]*>/gi)
            for (var i = 0; imgList && i < imgList.length; i++) {
                console.log('img:', imgList[i])
                var src = imgList[i].match(/src=['"]([^'"]*)['"]/i)
                if (src[1]) {
                    console.log('提取图片地址：', src[1])
                    auditImgs.push(src[1])
                }
            }

            // 开始提交审核
            if (this.isEnglish) {
                // 执行英文检测
                this.btnAuditLoading = true
                this.$axios.post('http://media.webwatch.com.cn:8080/bluefile/frontAPI/SpellCheckForEN', {
                    str: audit_text
                }).then(res => {
                    console.log('英文检测结果：', res.data)
                    if (res.data.errCode !== 0) {
                        this.$message({ message: res.data.errMsg, type: 'error' })
                    } else {
                        // 开始转换结果格式
                        console.log(res.data.alerts)
                        var typoList = []
                        for (var i = 0; i < res.data.alerts.length; i++) {
                            var alertList = res.data.alerts[i]
                            for (var j = 0; j < alertList.length; j++) {
                                var errObj = alertList[j]
                                console.log('english item:', errObj)
                                var sourceText = errObj.sourceText
                                var replaceText = errObj.replaceText
                                var errPos = errObj.start
                                if (errObj.alertType === 1) {
                                    replaceText = replaceText + sourceText
                                } else if (errObj.alertType === 2) {
                                    replaceText = sourceText + replaceText
                                } else if (errObj.alertType === 3) {
                                    replaceText = "建议删除"
                                } else if (errObj.alertType === 16) {
                                    continue
                                }
                                typoList.push({
                                    'index': errPos,
                                    'trueword': replaceText,
                                    'word': sourceText
                                })
                            }
                        }
                        console.log(typoList)
                        if (typoList.length == 0) {
                            this.$message({ message: '恭喜你，您审核的内容通过无误！', type: 'success' })
                        }
                        this.$refs.audit.setAuditResult(typoList, [], [], [])
                    }

                    this.btnAuditLoading = false
                }).catch(error => {
                    console.log(error)
                    this.btnAuditLoading = false
                })
            } else {
                // 生成 appsecret
                let date = new Date()
                let year = date.getFullYear()
                let month = ('0' + (date.getMonth() + 1)).slice(-2)
                let day = ('0' + date.getDate()).slice(-2)
                var appsecret = this.$md5(sessionStorage.getItem('appkey') + (year + month + day))

                this.btnAuditLoading = true
                this.$axios.post('/cmsMateService/servlet/SpellCheck', {
                    str: audit_text,
                    enhance_model: this.auditPattern1 == true ? 'on' : '',
                    smart_model: (this.auditPattern2 == true || this.auditPatternAISmart == true) ? 'on' : '',
                    sample_model: this.auditPatternSample == true ? 'on' : '',
                    suspect_flag: this.auditPattern3 == true ? 'on' : '',
                    deepseek_model: (this.auditPatternDP == true || this.auditPatternAISmart == true) ? 'on' : '',    
                    appkey: sessionStorage.getItem("appkey"),
                    appsecret: appsecret,
                    keep_format: this.keep_doc_style == true ? 'on' : ''
                }).then(res => {
                    console.log('识别结果：', res.data)
                    if (sessionStorage.getItem('username') === 'admin') {
                        if (res.data.smart_status && parseInt(res.data.smart_status) === 2) this.isSmartError = true
                        else this.isSmartError = false
                        if (res.data.xunfei_status && parseInt(res.data.xunfei_status) === 2) this.isXunFeiError = true
                        else this.isXunFeiError = false
                    } else { this.isSmartError = false; this.isXunFeiError = false }

                    if (res.data.code !== '200') {
                        if (parseInt(res.data.code) === 300) {
                            this.$message({ type: 'warning', message: res.data.err })
                            if (this.$root.clientType === 0) {
                                setTimeout(() => { this.$router.push({ path: '/recharge', query: { from: '1' } }) }, 2000);
                            }
                        } else if (parseInt(res.data.code) !== 500) {
                            this.$message({ message: res.data.err, type: "warning" })
                        }
                        this.btnAuditLoading = false
                    } else {
                        if(res.data.typoList.length == 0 && res.data.suspectList.length == 0 && res.data.stopList.length == 0 && 
                                res.data.senList.length == 0 && res.data.dscontent.length == 0) {
                            this.$message({ message: '恭喜你，您审核的内容通过无误！', type: 'success' })
                        }
                        this.deepseekResult = res.data.dscontent ? res.data.dscontent : ''
                        // this.deepseekResult = this.deepseekResult.replace(/\n/gi, '<br/>')
                        console.log('deepseek优化结果：', this.deepseekResult)
                        // 解析结果，展示结果
                        this.$refs.audit.setAuditResult(res.data.typoList, res.data.suspectList, res.data.stopList, res.data.senList, this.deepseekResult)
                        // 开始审核图片
                        if (auditImgs.length > 0) {
                            this.$axios.post('/cmsMateService/servlet/SpellCheckForImage', {
                                imgstr: auditImgs.join(';'),
                                enhance_model: this.auditPattern1 == true ? 'on' : '',
                                smart_model: this.auditPattern2 == true ? 'on' : '',
                                appkey: sessionStorage.getItem("appkey"),
                                appsecret: appsecret
                            }).then(res => {
                                console.log('图片审核结果：', res.data)
                                if (res.data.code !== '200') {
                                    this.$message({ type: 'warning', message: res.data.err })
                                } else {
                                    var _typo = []
                                    var _suspect = []
                                    var _stop = []
                                    var _sen = []
                                    for (var i = 0; i < res.data.result.length; i++) {
                                        for (var j = 0; j < res.data.result[i].typoList.length; j++) {
                                            var item = res.data.result[i].typoList[j]
                                            item.word = '【图' + (i + 1) + '】' + item.word
                                            item.img = true
                                            _typo.push(item)
                                        }
                                        for (var j = 0; j < res.data.result[i].suspectList.length; j++) {
                                            var item = res.data.result[i].suspectList[j]
                                            item.word = '【图' + (i + 1) + '】' + item.word
                                            item.img = true
                                            _suspect.push(item)
                                        }
                                        for (var j = 0; j < res.data.result[i].stopList.length; j++) {
                                            var item = res.data.result[i].stopList[j]
                                            item.word = '【图' + (i + 1) + '】' + item.word
                                            item.img = true
                                            _stop.push(item)
                                        }
                                        for (var j = 0; j < res.data.result[i].senList.length; j++) {
                                            var item = res.data.result[i].senList[j]
                                            item.word = '【图' + (i + 1) + '】' + item.word
                                            item.img = true
                                            _sen.push(item)
                                        }
                                    }
                                    this.$refs.audit.setImageResult(_typo, _suspect, _stop, _sen)
                                }

                                this.btnAuditLoading = false
                            }).catch(error => {
                                console.log(error)
                                this.btnAuditLoading = false
                            })
                        } else {
                            this.btnAuditLoading = false
                        }
                    }
                }).catch(error => {
                    console.log(error)
                    this.btnAuditLoading = false
                })
            }
        },
        btnUploadDocument (params) {
            console.log('开始上传文档')
            console.log(params)
            var fileName = params.file.name
            var fileType = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
            console.log('文件扩展:', fileType)
            if (['.doc', '.docx', '.txt', '.wps', '.pdf', '.jpg', '.jpeg', '.gif', '.png', '.bmp', '.ppt', '.pptx', '.xls', '.xlsx', '.ofd'].indexOf(fileType) == -1) {
                this.$message({type: 'warning', message: '暂不支持的文件格式'})
                return
            }
            // 判断上传文件大小，不允许超过100M
            if (params.file.size / 1024 / 1024 >= 100) {
                this.$message({ type: 'warning', message: '文件超过100M，请使用蓝太平洋Mediamate进行审核' })
                return
            }
            this.$refs.audit.cleanAudit()
            this.deepseekResult = ''

            this.keep_doc_style = true
            let formData = new FormData()
            formData.append('file', params.file)
            this.documentLoading = true; this.progressPercent = 0
            this.$axios({
                url: '/cmsMateService/servlet/Word2Content',
                method: 'post',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    // 'appId': '48d6215903dff56238e52e8891380c8f',
                    // 'appSecret': '59de6c1a1da98efa12424abf01c8b838'
                },
                onUploadProgress: this.onUploadProgress,
            }).then(res => {
                this.progressPercent = 100
                if (res.status !== 200) { this.$message({ type: 'warning', message: '上传失败' }) }
                else if (res.data.result !== '200') { this.$message({ type: 'warning', message: res.data.message }) }
                else {
                    this.$refs.audit.setAuditTxt(res.data.info.content)
                    this.deepseekResult = ''
                    this.isDocFile = true
                }
                this.documentLoading = false
                if(this.uploadTimer != null) { clearInterval(this.uploadTimer); this.uploadTimer = null; }
            }).catch(error => {
                this.documentLoading = false
                if(this.uploadTimer != null) { clearInterval(this.uploadTimer); this.uploadTimer = null; }
                console.log(error)
                this.$message({type: 'warning', message: '上传失败'})
            })
        },
        onUploadProgress (event, file, fileList) {
            // 使用定时器来制作进度条
            this.uploadTimer = setInterval(() => {
                // this.progressPercent += 0.3;
                var addPercent = 0.6;
                if(this.progressPercent <= 57) addPercent = 0.45;
                else if(this.progressPercent <= 75) addPercent = 0.22;
                else if(this.progressPercent <= 85) addPercent = 0.15;
                else if(this.progressPercent <= 96.6) addPercent = 0.06;
                else {
                    addPercent = 0;
                    clearInterval(this.uploadTimer)
                    this.uploadTimer = null
                }
                this.progressPercent = Number((this.progressPercent + addPercent).toFixed(2))
            }, 100);
        },
        progressFormat () {
            return () => {
                return this.progressPercent === 100 ? '上传完成' : '上传中'
            }
        },
        btnImportLink () {
            if (this.importLinkDlg.link == '') {
                this.$message({ type: 'warning', message: '请先输入网页链接' })
                return
            }
            var url = new URL(this.importLinkDlg.link)
            console.log('link: ', url)
            var baseUrl = url.origin
            this.keep_doc_style = true

            this.importLinkDlg.loading = true
            this.$axios.post('http://media.webwatch.com.cn:8080/bluefile/frontAPI/getWebSourceCode', {
                url: this.importLinkDlg.link
            }).then(res => {
                if (res.status !== 200) {
                    this.$message({ type: 'warning', message: '访问链接失败' })
                } else if (parseInt(res.data.result) !== 200) {
                    this.$message({ type: 'warning', message: res.data.message })
                } else {
                    this.isHtmlPage = true
                    // 设置网页源码到审核文本框中
                    var shtml = res.data.info.content
                    shtml = shtml.replace(/<head>/gi, '<head><base href="' + this.importLinkDlg.link + '"/>')
                    shtml = shtml.replace(/<br[^>]*>/gi, '')
                    // 设置baseurl，便于展示
                    console.log(shtml)
                    this.$refs.audit.setAuditHtml(shtml)
                    this.importLinkDlg.show = false
                }
                this.importLinkDlg.loading = false
            }).catch(() => {
                this.$message({ type: 'warning', message: '访问链接异常' })
                this.importLinkDlg.loading = false
            })
        },
        goAIWrite () {
            this.AIWrite.zhuti = ''
            this.AIWrite.background = ''
            this.AIWrite.detail = ''
            this.AIWrite.show = true
        },
        btnGenerateArticle () {
            if (this.AIWrite.zhuti.length === 0) {
                this.$message({ type: 'warning', message: '请输入创作主题' })
                return
            }
            if (this.AIWrite.background.length === 0) {
                this.$message({ type: 'warning', message: '请输入创作背景' })
                return
            }
            var sendMsg = '你是一名作家，请根据要求创作一篇文章：\r\n主题：' + this.AIWrite.zhuti + '\r\n背景：' + this.AIWrite.background
            if (this.AIWrite.detail.length > 0) {
                sendMsg += ('\r\n要求：' + this.AIWrite.detail)
            }
            // 参考：https://chatglm.cn/main/alltoolsdetail
            // 如果当前没有回话ID，需要先生成回话ID
            this.AIWrite.loading = true
            if (this.AIWrite.conversationId.length == 0) {
                this.$axios.post('/cmsMateService/login.do?method=createChat', {
                    username: sessionStorage.getItem('username')
                }).then(res => {
                    console.log(res.data)
                    if (parseInt(res.data.result) != 200) {
                        this.$message({ type: 'warning', message: 'AI撰写请求失败，请稍后再试(1)' })
                        this.AIWrite.loading = false
                    } else {
                        this.AIWrite.conversationId = res.data.conversation_id
                        this.SendAIMessage(sendMsg)
                    }
                }).catch(() => {
                    this.$message({ type: 'warning', message: 'AI撰写请求失败，请稍后再试(2)' })
                    this.AIWrite.loading = false
                })
            }
            else {
                this.SendAIMessage(sendMsg)
            }
        },
        SendAIMessage (message) {
            this.$axios.post('/cmsMateService/login.do?method=sendMessage', {
                username: sessionStorage.getItem('username'),
                query: message,
                conversation_id: this.AIWrite.conversationId
            }).then(res => {
                console.log(res.data)
                if (parseInt(res.data.result) != 200) {
                    this.$message({ type: 'warning', message: 'AI撰写请求失败，请稍后再试(3)' })
                    this.AIWrite.loading = false
                    return
                }
                // 设置回答响应结果
                this.AIWrite.show = false
                this.$refs.audit.setAuditTxt(res.data.answer)
                this.deepseekResult = ''
                this.AIWrite.loading = false
            }).catch(() => {
                this.$message({ type: 'warning', message: 'AI撰写请求失败，请稍后再试(4)' })
                this.AIWrite.loading = false
            })
        }
    },
    computed: {
        auditPattern1: {
            get () { return this.$root.auditPattern1 },
            set (val) {
                this.$root.auditPattern1 = val
            }
        },
        auditPattern2: {
            get () { return this.$root.auditPattern2 },
            set (val) {
                this.$root.auditPattern2 = val
            }
        },
        auditPattern3: {
            get () { return this.$root.auditPattern3 },
            set (val) {
                this.$root.auditPattern3 = val
            }
        },
        auditPatternDP: {
            get () { return this.$root.auditPatternDP },
            set (val) {
                this.$root.auditPatternDP = val
            }
        },
        auditPatternAISmart: {
            get () { return this.$root.auditPatternAISmart },
            set (val) {
                this.$root.auditPatternAISmart = val
            }
        },
        showAISmart () {
            if (this.$root.clientType == 1 || this.$root.clientType == 2) return true;
            return window.location.href.indexOf('service.cmsmate.com.cn') != -1 || window.location.href.indexOf('localhost') != -1
        },
        showPatternSample () {
            if (sessionStorage.getItem('username') == 'admin') return true
            else return false
        },
        showZhiNengPattern () {
            if (sessionStorage.getItem("nickname") === 'admin') {
                return true
            } else {
                return false
            }
        },
        showEnglish () {
            // 1-普通用户 4-测试用户 clientType=0标准版本：普通用户、测试用户，不是标准版本，都不开放英文监测
            if (this.userType == 1 || this.userType == 4 || this.$root.clientType !== 0) return false
            else return true
        },
        showDocUpload () {
            if (this.userType === 0 || this.userType === 3) return true
            else return false
        },
        userType () {
            return parseInt(sessionStorage.getItem('status'))
        },
        // 是否显示智能模式的选择
        showSmartMode () {
            return true
        },
        // 是否显示DeepSeek模式
        showDeepSeekMode () {
            // 0-管理员  3-VIP用户
            if (this.userType === 0 || this.userType === 3) return true
            else return false
        },
        openDocCheck () {
            if (this.userType !== 0 && this.userType !== 2 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('word_check'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        },
        openImgCheck () {
            if (this.userType !== 0 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('image_check'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        },
        openVideoCheck () {
            if (this.userType !== 0 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('video_check'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        },
        openAudioCheck () {
            if (this.userType !== 0 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('audio_check'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        },
        openWebpageCheck () {
            if (this.userType !== 0 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('link_check'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        },
        openAICreation () {
            if (this.userType !== 0 && this.userType !== 3) return false
            if (this.userType == 3) {
                var authInfo = JSON.parse(sessionStorage.getItem('article_creation'))
                if (parseInt(authInfo.state) == 1) return true
                else return false
            }
            else return true
        }
    },
    watch: {
        isEnglish (val) {
            if (val === true) {
                this.auditPattern1 = false
                this.auditPattern2 = false
                this.auditPattern3 = false
            } else {
                this.auditPattern1 = true
                this.auditPattern2 = false
                this.auditPattern3 = true
            }
        }
    },
    mounted() {
        this.statuss = sessionStorage.getItem("status");
        console.log(this.statuss);
        this.nickName = sessionStorage.getItem("nickname");
        this.userName = sessionStorage.getItem('username')
        this.genre = sessionStorage.getItem("genre");
        console.log(this.nickName, this.userName);
        if (this.nickName) {
            this.exit = false;
        }

        console.log('userType:', this.userType)

        if (this.isEnglish === false) {
            this.auditPattern1 = true
            this.auditPattern2 = false
            // this.auditPattern3 = true
        } else {
            this.auditPattern1 = false
            this.auditPattern2 = false
            // this.auditPattern3 = false
        }

        if (this.$route.params.type === 'webpage') {
            setTimeout(() => {
                this.importLinkDlg.link = ''
                this.importLinkDlg.show = true
            }, 500);
        }
    },
};
</script>

<style lang="less">
/deep/.el-collapse-item__header {
    background: aliceblue;
    padding: 0 10px;
}
/deep/.el-dialog__header {
    background: #59b0b31c;
}
.navdown {
    border: 1px solid greenyellow !important;
}

.dropdown {
    position: absolute;
    padding: 10px;
    color: #fff;
    background: #333;
    border-radius: 3px;
    box-shadow: 0 0 3px rgb(0 0 0 / 25%);
}
/deep/.el-badge__content {
    font-size: 9px;
    height: 20px;
    background-color: #f44336e3;
}
/deep/.el-checkbox__inner {
    border: 1px solid #409eff !important;
}
/deep/.el-empty {
    padding: 30px 0;
    margin: 0px 13.5vw;
    .el-empty__description {
        width: 60px;
        margin-top: 10px;
    }
    .el-empty__image {
        width: 100px;
    }
    .el-empty__description p {
        color: #fff;
    }
}

.table-color-green {
    background-color: green;
}

.table-color-grey {
    background-color: #696969;
}
.table-color-black {
    background-color: black;
}

.sub-title-con {
    font-size: 13px;
    cursor: default;
    color: #000;
    position: absolute;
    line-height: 30px;
    left: 24px;
    top: 82px;
    .tag-correct {
        margin-right: 8px;
        background: #f4433608;
        color: red;
        border: 1px solid red !important;
        border-radius: 4px;
        padding: 4px 6px;
    }
    .tag-sense {
        background: #ff98000a;
        color: #ff9800;
        margin-right: 8px;
        padding: 4px 6px;
        border: 1px solid #ff9800 !important;
        border-radius: 4px;
    }
    .tag-sense1 {
        background: #9c27b014;
        color: #9c27b0;
        margin-right: 8px;
        padding: 4px 6px;
        border: 1px solid #9c27b0 !important;
        border-radius: 4px;
    }
    .tag-sense2 {
        background: #2196f314;
        color: #2196f3;
        margin-right: 8px;
        padding: 4px 6px;
        border: 1px solid #2196f3 !important;
        border-radius: 4px;
    }
}

.set {
    position: fixed;
    top: 21px;
    right: 6%;
    border: 1px solid !important;
    z-index: 100;
    padding: 2px 10px;
    border-radius: 4px;
    cursor: pointer;
    color: #d6d6d6;
}
</style> 


// WEBPACK FOOTER //
// src/components/home.vue